export const isMobile = () =>
	/iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
